<div
  class="theme-selector"
  [class.theme-selector--stretch]="stretch"
  [class.is-ready]="animationsEnabled"
  [style.--active-index]="activeIndex"
  role="group"
  aria-label="Theme mode selector"
>
  <span class="theme-selector__indicator" aria-hidden="true"></span>
  @for (option of themeOptions; track option.mode) {
    <button
      type="button"
      class="theme-selector__button"
      [class.is-active]="currentTheme === option.mode"
      [attr.aria-label]="option.title"
      [attr.aria-pressed]="currentTheme === option.mode"
      [title]="option.title"
      (click)="changeTheme(option.mode)"
    >
      <span class="theme-selector__icon-wrap">
        <ion-icon [name]="option.icon"></ion-icon>
      </span>
    </button>
  }
</div>
